import { render, staticRenderFns } from "./NotificationSnackbar.vue?vue&type=template&id=ec60da62&"
import script from "./NotificationSnackbar.vue?vue&type=script&lang=js&"
export * from "./NotificationSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSnackbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
